import Leagues from "@Enums/Leagues";
import { getLeagueColor } from "@Helpers/league-utils";
import { Box, Stack, useTheme } from "@mui/material";

interface IBybLeagueProgress {
  league: Leagues;
  division: number;
  divisions: number;
}

const BybLeagueProgress = ({ league, division, divisions }: IBybLeagueProgress) => {
  const theme = useTheme();
  return (
    <Stack direction="row" spacing={0.5}>
      {[...Array(divisions)].map((_, index) => (
        <Box
          key={index}
          sx={{
            position: "relative",
            width: "fill-available",
            height: theme.spacing(0.75),
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundColor: getLeagueColor(league, theme),
              borderRadius: "2px",
              opacity: divisions - division >= index ? "100%" : "22%",
            }}
          />
        </Box>
      ))}
    </Stack>
  );
};

export default BybLeagueProgress;
